import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TrialChip({ className = "" }) {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Same backend source (trial_days_left) as the sidebar, Billing page and TrialBanner.
  const days = user?.trial_days_left;
  if (user?.subscription_status !== "trialing" || typeof days !== "number" || days < 0) return null;

  const urgent = days <= 3;
  const tone = urgent
    ? "bg-red-50 text-red-700 border-red-200"
    : "bg-amber-50 text-amber-800 border-amber-200";

  return (
    <Link
      to="/app/billing"
      data-testid="trial-chip"
      title={t("trialBanner.daysLeft", { count: days })}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-medium leading-none transition-colors hover:opacity-90 ${tone} ${className}`}
    >
      <Clock className="h-3 w-3" />
      {t("trialBanner.chip", { count: days })}
    </Link>
  );
}
